import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { AnimatePresence, motion } from "framer-motion";
import CardWithNumber from "../generic/CardWithNumber";

const ConnectTrackScale = () => {
  const howItWorksItems = [
    {
      number: 1,
      title: "Connect Your Ad Sources",
      subtitle: "Set up in minutes with all major ad platforms and app stores.",
      description:
        "Easily link your ad networks and app store accounts for seamless data collection and tracking.",
    },

    {
      number: 2,
      title: "Track the Full Journey",
      subtitle: "See user behavior across platforms, devices, and campaigns.",
      description:
        "Monitor the entire funnel—from click to install to in-app actions—in one unified view.",
    },
    {
      number: 3,
      title: "Optimize and Scale",
      subtitle: "Focus on what works, cut what doesn’t.",
      description:
        "Identify top-performing ads and channels, reduce wasted spend, and grow faster with data-backed decisions.",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"connectTrackScale"}>
        <Line>
          <TextWrapper>
            <Title>Connect, Track, and Scale with Confidence</Title>
            <Subtitle>
              Easily integrate your ad platforms, gain complete visibility into
              user journeys across channels, and focus your budget on the
              campaigns that deliver real results—no more guesswork, just
              smarter growth.
            </Subtitle>
          </TextWrapper>
        </Line>
        <ItemsWrapper>
          {howItWorksItems.map((item, index) => (
            <CardWithNumber
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              description={item.description}
              number={item.number}
            />
          ))}
        </ItemsWrapper>
      </Container>
    </FullPageContainer>
  );
};

export default ConnectTrackScale;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.lightColorFaded7};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  @media (max-width: 990px) {
    gap: 30px;
    flex-direction: column;
  }
`;

const ItemsWrapper = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  width: 100%;

  & > * {
    max-width: 600px;
    width: 100%;
  }

  @media (max-width: 990px) {
    flex-direction: column;
    align-items: center;
    width:100%;
    flex-wrap:unset;
    & > * {
      width: 100%;

    }
  }
`;
